import type { JSX } from 'react';
import { Link } from 'react-router';

import styles from './styles.module.css';

export function ProviderHero(): JSX.Element {
  return (
    <>
      <section className={styles.hero}>
        <div className={styles.wrap}>
          <div className={styles.heroGrid}>
            <div>
              <span className={styles.eyebrow}>Medicare ACCESS · Digital Nutrition Care</span>
              <h1>
                Refer a patient to{' '}
                <span className={styles.coral}>covered digital nutrition care.</span>
              </h1>
              <p className={styles.heroLede}>
                NourishedRx pairs your eligible Medicare patients with <strong>Betty</strong>, an AI
                health companion, plus registered-dietitian support — a fully digital program{' '}
                <strong>at no cost to them.</strong> You stay informed — care coordination made
                easy.
              </p>
              <div className={styles.heroCta}>
                <Link to="/refer" className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg}`}>
                  Submit a referral
                </Link>
                <a href="#how" className={`${styles.btn} ${styles.btnGhost}`}>
                  How it works
                </a>
              </div>
              <p className={styles.heroSubtext}>
                Referral takes about 5 minutes · No login required
              </p>
            </div>
            <div className={styles.heroPhoto}>
              <img
                className={styles.heroImgSlot}
                src="/images/prov-hero.webp"
                alt="Clinician coordinating patient care"
              />
              <div className={styles.heroFloat}>
                <span className={styles.heroFloatDot}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--coral-dark)"
                    strokeWidth="2.2"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </span>
                <span>
                  Eligibility verified
                  <br />
                  <small>in real time via CMS</small>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cross-link for misdirected beneficiaries */}
      <div className={`${styles.wrap} ${styles.crosslinkWrap}`}>
        <div className={styles.crosslink}>
          <p>👋 Are you a Medicare beneficiary looking to join? Here's how to get started.</p>
          <Link to="/#beneficiary">See how it works for members →</Link>
        </div>
      </div>
    </>
  );
}
